import { fromEvent } from 'rxjs'

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators'

const inputChanges = (input) =>
  fromEvent(input, 'keyup').pipe(
    debounceTime(400),
    map((e) => $(e.target).val()),
    distinctUntilChanged(),
  )

export default inputChanges
